import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformToolSpreadsheetEditorComponent} from '@features/spreadsheet/components/platform-tool-spreadsheet-editor/platform-tool-spreadsheet-editor.component';
import { SpreadsheetManageEntityDialogComponent } from './components/dialog-components/spreadsheet-manage-entity-dialog/spreadsheet-manage-entity-dialog.component';
import { ManageStageAreaDialogComponent } from './components/dialog-components/manage-stage-area-dialog/manage-stage-area-dialog.component';
import { CreateQuestionnaireFromExcelDialogComponent } from './components/dialog-components/create-questionnaire-from-excel-dialog/create-questionnaire-from-excel-dialog.component';
import {ExcelTableInputCardComponent} from '@features/spreadsheet/components/cards/excel-table-input-card/excel-table-input-card.component';
import { ExcelColumnCellViewerComponent } from './components/cell-viewer/excell-column-cell-viewer/excell-column-cell-viewer.component';
import {InlineWorker} from '@core/models/inline-worker';
import {FormulaFieldCellViewerComponent} from '@features/spreadsheet/components/cell-viewer/formula-field-cell-viewer/formula-field-cell-viewer.component';
import {
  StepByStepWorkbookGuideCardComponent
} from '@features/spreadsheet/components/cards/step-by-step-workbook-guide-card/step-by-step-workbook-guide-card.component';
import {
  SpreadsheetGuidedTourComponent
} from '@features/spreadsheet/components/spreadsheet-guided-tour/spreadsheet-guided-tour.component';
import {
  OverwriteReviewSidebarComponent
} from '@features/spreadsheet/components/overwrite-review-sidebar/overwrite-review-sidebar.component';
import {ExcelFootNoteComponent} from '@features/spreadsheet/components/sidenotes/excel-foot-note/excel-foot-note.component';
import {FormViewInstructionsComponent} from '@features/spreadsheet/components/sidenotes/form-view-instructions/form-view-instructions.component';
import {SpreadsheetSearchDialogComponent} from '@features/spreadsheet/components/dialog-components/spreadsheet-search-dialog/spreadsheet-search-dialog.component';
import {StepByStepProcessComponent} from '@features/spreadsheet/components/step-by-step-process/step-by-step-process.component';
import {ValidationWarningsIconCellViewerComponent} from "@features/spreadsheet/components/cell-viewer/validation-warnings-icon-cell-viewer/validation-warnings-icon-cell-viewer.component";
import {ButtonCellViewerComponent} from "@features/spreadsheet/components/cell-viewer/button-cell-viewer/button-cell-viewer.component";
import {AbbreviationsComponent} from "@features/spreadsheet/components/sidenotes/abbreviations/abbreviations.component";
import {
  ReportWorksheetDetailsAndInstructionsComponent
} from "@features/spreadsheet/components/sidenotes/worksheet-details-and-instructions/report-worksheet-details-and-instructions.component";
import {ScenarioActivityComponent} from '@features/spreadsheet/components/scenario-activity/scenario-activity.component';

// @dynamic
export class SpreadsheetDynamicComponentHelper {
  public static components: any;
  public static init() {
    if (SpreadsheetDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['PlatformToolSpreadsheetEditorComponent'] = PlatformToolSpreadsheetEditorComponent;
    components['ManageStageAreaDialogComponent'] = ManageStageAreaDialogComponent;
    components['SpreadsheetManageEntityDialogComponent'] = SpreadsheetManageEntityDialogComponent;
    components['CreateQuestionnaireFromExcelDialogComponent'] = CreateQuestionnaireFromExcelDialogComponent;
    components['SpreadsheetSearchDialogComponent'] = SpreadsheetSearchDialogComponent;
    components['ExcelTableInputCardComponent'] = ExcelTableInputCardComponent;
    components['StepByStepWorkbookGuideCardComponent'] = StepByStepWorkbookGuideCardComponent;
    components['ExcelColumnCellViewer'] = ExcelColumnCellViewerComponent;
    components['FormulaFieldCellViewerComponent'] = FormulaFieldCellViewerComponent;
    components['ValidationWarningsIconCellViewerComponent'] = ValidationWarningsIconCellViewerComponent;
    components['ButtonCellViewerComponent'] = ButtonCellViewerComponent;
    components['SpreadsheetGuidedTourComponent'] = SpreadsheetGuidedTourComponent;
    components['OverwriteReviewSidebarComponent'] = OverwriteReviewSidebarComponent;
    components['AbbreviationsComponent'] = AbbreviationsComponent;
    components['ExcelFootNoteComponent'] = ExcelFootNoteComponent;
    components['StepByStepProcessComponent'] = StepByStepProcessComponent;
    components['FormViewInstructionsComponent'] = FormViewInstructionsComponent;
    components['ReportWorksheetDetailsAndInstructionsComponent'] = ReportWorksheetDetailsAndInstructionsComponent;
    components['ScenarioActivityComponent'] = ScenarioActivityComponent;
    SpreadsheetDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static getComponentArray(): any[] {
    SpreadsheetDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(SpreadsheetDynamicComponentHelper.components).forEach(key => {
      componentArray.push(SpreadsheetDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    SpreadsheetDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}


// const worker = new InlineWorker(() => {
// });
//
// worker.postMessage({ limit: 300000 });
//
// worker.onmessage().subscribe((data) => {
//   worker.terminate();
// });
//
// worker.onerror().subscribe((data) => {
// });
